import {
	fetchPPPSeznamQuery,
	type NahledyudajuPppVypisSeznamPppParams,
	useAxiosInstance,
	usePoQuery,
} from '@gov-nx/api';

export const usePPPSeznamQuery = (
	params: NahledyudajuPppVypisSeznamPppParams,
	rezaKod?: string
) => {
	const { axiosInstance } = useAxiosInstance();
	return usePoQuery({
		queryKey: ['ppp-seznam', rezaKod ?? '', params],
		queryFn: () => fetchPPPSeznamQuery(axiosInstance, params),
	});
};
